import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { observer, inject } from 'mobx-react'
import * as helpers from '../lib/HelperFunctions'
import { Deck, Slide, Heading, Layout, Fill, Fit, Image, Text } from "spectacle"
import { Glyphicon } from 'react-bootstrap'
// import preloader from "spectacle/lib/utils/preloader";
import createTheme from "spectacle/lib/themes/default"
import firebase from '../firebase'
import { toJS } from 'mobx'
import Logger from '../stores/Logger'
import RecommendationLabel from '../components/RecommendationLabel'
// require("spectacle/lib/themes/default/index.css");
import ToolTip from '../components/ToolTip.js'
import ViabilityTool from '../components/ViabilityTool.js'
import IdeaStage from '../components/IdeaStage'
import TimelineTool from '../components/TimelineTool.js'
import '../containers/css/PresentIdea.css'
import { browserHistory } from 'react-router'
import KeyHandler, { KEYDOWN } from 'react-key-handler'

class PresentIdea extends Component {
    constructor(props) {
        super(props)
        this.renderSlide = this.renderToolSlide.bind(this)
        this.introSlide = this.introSlide.bind(this)
        this.teamSlide = this.teamSlide.bind(this)
        this.dummy = this.dummy.bind(this)
        this.onKeyPress = this.onKeyPress.bind(this)
        this.trimText = this.trimText.bind(this)
        this.trimOneLineText = this.trimOneLineText.bind(this)
        this.state = {
            existingIdeaKey: undefined,
            showElement: true,
            loadedTeamStages: [],
            loadedTeamTools: [],
        }
    }
    componentWillMount() {
        const { stores } = this.props
        const { store, authStore, prefStore, toolStore } = stores
        let thing = this
        let noTeamStages = toolStore.defaultStages.toJSON()
        let noTeamTools = toolStore.defaultTools.toJSON()
        // console.log('got idea key:'+this.props.params.ideaKey)
        this.unwatchAuth = authStore.watchAuth(user => {
            if (user) {
                store.loadIdeaWithKey(this.props.params.ideaKey)
                this.setState({ existingIdeaKey: this.props.params.ideaKey })
                prefStore.loadTeamPrefs(thing.props.params.ideaKey).then(() => {
    
                    if (prefStore.defaultIdeaStages.length > 0){
                        this.setState({
                            loadedTeamStages: prefStore.defaultIdeaStages.toJSON(),
                        })
                    } else {
                        firebase.database().ref().child('stages').once('value',stagesSnap => {
                            if(stagesSnap.exists()){
                                noTeamStages = stagesSnap.val()
                                this.setState({
                                    loadedTeamStages: noTeamStages,
                                })
                            }
                        })
                    }

                    ////////////////////////

                    if (prefStore.defaultIdeaTools.length > 0){
                        this.setState({
                            loadedTeamTools: prefStore.defaultIdeaTools,
                        })
                    } else {
                        firebase.database().ref().child('tools').once('value',toolsSnap => {
                            if(toolsSnap.exists()){
                                noTeamTools = toolsSnap.val()
                                this.setState({
                                    loadedTeamTools: noTeamTools,
                                })
                            }
                        })
                    }
                })
            }
        }, error => {
            console.log('watchAuth error: ' + JSON.stringify(error))
        })
    }

    componentWillUnmount() {
        if (this.unwatchAuth) {
            this.unwatchAuth()
            this.unwatchAuth = null
        }
    }

    onKeyPress(e) {
        if (e.key === '27') {
            Logger.trackEvent('presentCloseWithESC')
            browserHistory.goBack()
        }
    }

    sketchSlide() {
        let slide = null
        const { stores } = this.props
        const { store } = stores
        const { theIdea } = store
        if (theIdea.gotSketch) {
            slide =
                <Slide align='flex-start' className='ideaAndNeedSlides' style={{ position: 'relative' }} progressColor={theIdea.slideHeaderColor} controlColor={theIdea.slideHeaderColor} key={1} bgColor={theIdea.slideBgColor}>
                    <Heading className='introSlideName' key={2} style={{ fontSize: 3 + 'vw' }} caps textColor={theIdea.slideHeaderColor}>
                        Sketch
                    </Heading>
                    <div className='centeredContentInSketch'>
                        <Image key={3} src={theIdea.gotSketch} className='sketchImage' />
                        {theIdea.sketchText &&
                            <Text className='wordBreakImages' key={4} textColor={theIdea.slideTextColor}>
                                {this.trimOneLineText(theIdea.sketchText, '')}
                            </Text>
                        }
                    </div>
                </Slide>
            return slide
        }
    }

    imageSlides() {
        let slide = null
        const { stores } = this.props
        const { store } = stores
        const { theIdea } = store
        const imageUrls = theIdea.imageUrls
        let top = 50 + '%'
        if (theIdea.imageText) {
            top = 40 + '%'
        }
        if (theIdea.imageUrls) {
            slide =
                imageUrls.map((theImg, index) =>
                    <Slide align='flex-start' className='imagesSlide' progressColor={theIdea.slideHeaderColor} controlColor={theIdea.slideHeaderColor} bgColor={theIdea.slideBgColor} key={index}>
                        <div className='centeredContentInSlide'>
                            <img
                                style={{ top: top }}
                                alt='slideIllustration'
                                src={theImg}
                                className='slideImages'
                                key={index + 5} />
                        </div>
                        {theIdea.imageText &&
                            <Text className='wordBreakImages' textColor={theIdea.slideTextColor} textSize={2 + 'vw'} key={index + 2}>
                                {this.trimOneLineText(theIdea.imageText, '')}
                            </Text>
                        }
                    </Slide>,
                )
            return slide
        }
    }

    timelineSlide() {
        let slide = null
        const { stores } = this.props
        const { store } = stores
        const { theIdea } = store
        let currentSteps = null
        let stepAmount = ''
        if (theIdea.timelineRows && theIdea.timelineRows.length > 0) {
            currentSteps = toJS(theIdea.timelineRows)
            if (currentSteps.length > 4) {
                stepAmount = 'centeredContentInViabilityVer'
            }
            else {
                stepAmount = 'centeredContentInViabilityHor'
            }
            slide =
                <Slide align='flex-start' className='ideaAndNeedSlides' progressColor={theIdea.slideHeaderColor} controlColor={theIdea.slideHeaderColor} key={5} bgColor={theIdea.slideBgColor}>
                    <Heading className='introSlideName' key={6} style={{ fontSize: 3 + 'vw' }} caps textColor={theIdea.slideHeaderColor}>Timeline</Heading>
                    <div className={stepAmount}>
                        <div key={7} style={{ color: theIdea.slideTextColor }} className='timelineSlide'>
                            <TimelineTool
                                shouldShow={false}
                                timelineRows={currentSteps}
                                activeStep={theIdea.activeTimelineStep}
                                stepperColor={theIdea.slideTextColor}
                                activeBlipColor={theIdea.slideHeaderColor}
                                activeCircleColor={theIdea.slideHeaderColor}
                                completedBarColor={theIdea.slideHeaderColor}
                                onChangeCurrentTimelinePoint={this.dummy.bind(this)}
                                onAddRow={this.dummy.bind(this)}
                                onEditRow={this.dummy.bind(this)}
                                onDeleteRow={this.dummy.bind(this)}
                            />
                        </div>
                    </div>
                </Slide>
            return slide
        }
    }

    viabilitySlide() {
        let slide = null
        const { stores } = this.props
        const { store } = stores
        const { theIdea } = store
        if (theIdea.costRows && theIdea.revenueRows) {
            slide =
                <Slide align='flex-start' className='ideaAndNeedSlides' progressColor={theIdea.slideHeaderColor} controlColor={theIdea.slideHeaderColor} key={8} bgColor={theIdea.slideBgColor}>
                    <Heading className='introSlideName' key={9} style={{ fontSize: 2 + 'vw' }} caps textColor={theIdea.slideHeaderColor}>
                        Costs and Revenue
                    </Heading>
                    <Fit key={10} className='viabilityContainer'>
                        <div key={11} className='slideViability' style={{ color: theIdea.slideTextColor }} >
                            <ViabilityTool
                                costRows={toJS(theIdea.costRows)}
                                revenueRows={toJS(theIdea.revenueRows)}
                                hoverEffect={false}
                                shouldShow={false}
                                titleSize={1.5}
                                shouldHide={true}
                                editMode='none'
                                onAddCostRow={this.dummy.bind(this)}
                                onEditCostRow={this.dummy.bind(this)}
                                onDeleteCostRow={this.dummy.bind(this)}
                                onAddRevenueRow={this.dummy.bind(this)}
                                onEditRevenueRow={this.dummy.bind(this)}
                                onDeleteRevenueRow={this.dummy.bind(this)}
                                onTextChange={this.dummy.bind(this)}
                            />
                        </div>
                    </Fit>
                    <Fit key={12}>
                        <Text key={11} textColor={theIdea.slideTextColor} className='viabilityWordBreak' style={{ marginTop: 40 + 'px' }} textSize={1.2 + 'vw'} textAlign='left'>{this.trimText(theIdea.viabilityText)}</Text>
                    </Fit>
                </Slide>
            return slide
        }
    }

    teamSlide() {
        let slide = null
        const { stores } = this.props
        const { store } = stores
        const { theIdea } = store
        const team = theIdea.team
        if (theIdea.team || theIdea.hasOwnProperty('responsible')) {
            slide =
                <Slide align='flex-start' className='ideaAndNeedSlides' progressColor={theIdea.slideHeaderColor} controlColor={theIdea.slideHeaderColor} key={14} bgColor={theIdea.slideBgColor}>
                    <Heading key={15} className='introSlideName' style={{ paddingBottom: 80 + 'px', fontSize: 3.5 + 'vw' }} caps textColor={theIdea.slideHeaderColor}>
                        TEAM
                </Heading>
                    <Layout key={16}>
                        <Fit key={17}>
                            {theIdea.owner &&
                                <Fill key={18}>
                                    <Heading key={19} style={{ fontSize: 2 + 'vw', textAlign: 'left' }} caps textColor={theIdea.slideHeaderColor}>
                                        ORIGINATOR
                                </Heading>
                                    <div key={20} style={{ marginTop: 10 + 'px' }} className='teamContainer'>
                                        <div key={21} className='teamOwnerImage'>
                                            <img
                                                onError={(e)=>{helpers.onImageError(e, theIdea.ownerName)}}
                                                className='owner-profileImage'
                                                key={22}
                                                src={theIdea.ownerPhotoURL}
                                                alt='OwnerProfileImage'
                                            />
                                        </div>
                                        <div key={23} className='teamOwnerNameWrapper'>
                                            <div style={{ fontSize: 1.4 + 'vw', color: theIdea.slideTextColor, paddingTop: 20 + 'px' }}>{theIdea.ownerName}</div>
                                            {/* <Text>{theIdea.owner}</Text> */}
                                        </div>
                                    </div>
                                </Fill>
                            }
                            <Fill key={25}>
                                <br />&nbsp;
                        </Fill>
                            {theIdea.hasOwnProperty('responsible') &&
                                <Fill key={30}>
                                    <Heading key={19} style={{ fontSize: 2 + 'vw', textAlign: 'left' }} caps textColor={theIdea.slideHeaderColor}>
                                        Responsible
                            </Heading>
                                    <div key={20} style={{ marginBottom: 20 + 'px', marginTop: 10 + 'px' }} className='teamContainer'>
                                        <div key={21} className='teamCoCreatorImage'>
                                            <img
                                                onError={(e)=>{helpers.onImageError(e, theIdea.responsible.fullName)}}
                                                className='cocreator-profileImage'
                                                key={22}
                                                src={theIdea.responsible.photoURL}
                                                alt='CocreaterProfileImage'
                                                />
                                        </div>
                                        <div key={23} className='teamOwnerNameWrapper'>
                                            <div style={{ fontSize: 1.4 + 'vw', color: theIdea.slideTextColor, paddingTop: 20 + 'px' }}>{theIdea.responsible.fullName}</div>
                                            {/* <Text>{theIdea.owner}</Text> */}
                                        </div>
                                    </div>
                                </Fill>
                            }
                            {(theIdea.team && theIdea.team.length > 0) &&
                                <Fill key={26}>
                                    <Heading key={27} style={{ fontSize: 2 + 'vw', textAlign: 'left' }} caps textColor={theIdea.slideHeaderColor}>
                                        CO-CREATORS
                                </Heading>
                                    <div key={28} className='teamCoCreatorContainer'>
                                        {team.map((member, index) =>
                                            <div className='teamCoCreatorWrapper' key={index}>
                                                {member.hasOwnProperty('userId') &&
                                                    <div key={index + 4} className='teamCoCreatorImage'>
                                                        <img
                                                            onError={(e)=>{helpers.onImageError(e, member.fullName)}}
                                                            className='cocreator-profileImage'
                                                            key={index + 6}
                                                            src={member.photoURL}
                                                            alt='CocreaterProfileImage'
                                                            />
                                                    </div>
                                                }
                                                {member.hasOwnProperty('teamId') &&
                                                    <div key={index + 4} className='teamIdCoCreatorImage'>
                                                        <img
                                                            className='teamCocreator-profileImage'
                                                            key={index + 6}
                                                            src={member.photoURL}
                                                            alt='CocreaterProfileImage'
                                                            />
                                                    </div>
                                                }
                                                <div key={index + 13} className='teamCoCreatorTextWrapper'>
                                                    <Text className='cocreator-text' key={index + 7} textColor={theIdea.slideTextColor} style={{ textAlign: 'left', fontSize: 1.4 + 'vw' }}>{member.fullName}</Text>
                                                </div>
                                            </div>,
                                        )}
                                    </div>
                                </Fill>
                            }
                        </Fit>
                    </Layout>
                </Slide>
            return slide
        }
    }

    moreDescriptionSlide() {
        let slide = null
        const { stores } = this.props
        const { store } = stores
        const { theIdea } = store
        if (theIdea.moreDescription !== '' && theIdea.moreDescription !== '<p><br></p>' && theIdea.moreDescription !== '<p> </p>') {
            slide =
                <Slide align='flex-start' className='ideaAndNeedSlides' progressColor={theIdea.slideHeaderColor} controlColor={theIdea.slideHeaderColor} key={29} bgColor={theIdea.slideBgColor}>
                    <Text key={30} textColor={theIdea.slideTextColor}>
                        <span key={31} style={{ color: theIdea.slideTextColor }} className='htmlSpan' dangerouslySetInnerHTML={{ __html: theIdea.moreDescription }} />
                    </Text>
                </Slide>
            return slide
        }
    }

    introSlide(number) {
        let slide = null
        const { stores } = this.props
        const { store } = stores
        const { theIdea } = store
        let ideaImageStyle = ''
        let ideaTitleStyle = ''
        if (theIdea.description !== undefined && theIdea.description !== '') {
            ideaImageStyle = 'slideRightImageSide'
            ideaTitleStyle = 'introSlideName'
        }
        else {
            ideaImageStyle = 'noIdeaDescImageSide'
            ideaTitleStyle = 'introNoDescSlideName'
        }
        if (theIdea.name && (theIdea.description || theIdea.imageUrl)) {
            slide =
                <Slide align='flex-start' className='ideaAndNeedSlides' progressColor={theIdea.slideHeaderColor} controlColor={theIdea.slideHeaderColor} key={32} bgColor={theIdea.slideBgColor}>
                    <Heading key={33} style={{ fontSize: 3 + 'vw' }} className={ideaTitleStyle} caps textColor={theIdea.slideHeaderColor}>
                        {this.trimOneLineText(theIdea.name, 'title')}
                    </Heading>
                    {theIdea.description !== undefined && theIdea.description !== "" &&
                        <h3 key={36} className='introTitle' style={{ color: theIdea.slideHeaderColor }}><span style={{ color: theIdea.slideTextColor }}> Idea description:</span></h3>
                    }
                    {theIdea.imageUrl &&
                        <div className={ideaImageStyle} key={38}>
                            <Image key={34} className='introImage' src={theIdea.imageUrl} />
                        </div>
                    }
                    {theIdea.description !== undefined && theIdea.description !== "" &&
                        <div className='slideLeftTextSide' key={35}>
                            <div key={11} style={{ color: theIdea.slideTextColor, fontSize: 1.4 + 'vw', textAlign: 'left' }} className='wordBreak'>
                                {this.trimText(theIdea.description)}
                            </div>
                        </div>
                    }
                </Slide>
            return slide
        }
    }
    needSlide() {
        let slide = null
        const { stores } = this.props
        const { store } = stores
        const { theIdea } = store
        let ideaImageStyle = ''
        let ideaTitleStyle = ''
        if (theIdea.need !== undefined && theIdea.need !== '') {
            ideaImageStyle = 'slideRightImageSide'
            ideaTitleStyle = 'introSlideName'
        }
        else {
            ideaImageStyle = 'noIdeaDescImageSide'
            ideaTitleStyle = 'introNoDescSlideName'
        }
        if (theIdea.need !== '' || theIdea.needImageUrl) {
            slide =
                <Slide align='flex-start' className='ideaAndNeedSlides' progressColor={theIdea.slideHeaderColor} controlColor={theIdea.slideHeaderColor} key={38} bgColor={theIdea.slideBgColor}>
                    <Heading key={39} style={{ fontSize: 3 + 'vw' }} className={ideaTitleStyle} caps textColor={theIdea.slideHeaderColor}>
                        NEED
                        </Heading>
                    {theIdea.need !== undefined && theIdea.need &&
                        <h3 key={41} className='introTitle' style={{ color: theIdea.slideHeaderColor }}><span style={{ color: theIdea.slideTextColor }} >Idea description:</span></h3>
                    }
                    {theIdea.needImageUrl &&
                        <div className={ideaImageStyle} key={45}>
                            <Image key={40} src={theIdea.needImageUrl} className='needImage' />
                        </div>
                    }
                    {theIdea.need !== undefined && theIdea.need &&
                        <div className='slideLeftTextSide'>
                            <Text key={11} textColor={theIdea.slideTextColor} className='wordBreak' textSize={1.4 + 'vw'} textAlign='left'>
                                {this.trimText(theIdea.need)}
                            </Text>
                        </div>
                    }
                </Slide>
            return slide
        }
    }

    outroSlide() {
        let slide = null
        const { stores } = this.props
        const { store } = stores
        const { theIdea } = store
        slide =
            <Slide align='flex-start' className='ideaAndNeedSlides' style={{ position: 'relative' }} progressColor={theIdea.slideHeaderColor} controlColor={theIdea.slideHeaderColor} key={43} bgColor={theIdea.slideBgColor}>
                <Text key={45} className='centeredOutroSlide' textColor={theIdea.slideHeaderColor}>
                    Thank You!
                </Text>
            </Slide>
        return slide
    }

    stagesSlide(stages) {
        let slide = null
        const { stores } = this.props
        const { store } = stores
        const { theIdea } = store
        var dueDate = null
        let stageHeight = 50 + '%'
        let flexDirection = ''
        let justifyContent = ''
        let marginTop = 20
        if (theIdea.hasOwnProperty('dueDate') && theIdea.dueDate !== '') {
            stageHeight = 20 + '%'
            marginTop = 0
            flexDirection = 'column'
            justifyContent = 'space-between'
            dueDate = new Date(theIdea.dueDate)
            dueDate = dueDate.getDate() + '.' + (dueDate.getMonth() + 1) + '.' + dueDate.getFullYear()
        }
        else {
            marginTop = 20
            stageHeight = 50 + '%'
            flexDirection = ''
            justifyContent = ''
        }
        slide =
            <Slide align='flex-start' className='stagesSlides' progressColor={theIdea.slideHeaderColor} controlColor={theIdea.slideHeaderColor} key={53} bgColor={theIdea.slideBgColor}>
                <Heading className='introSlideName' key={54} style={{ fontSize: 3 + 'vw' }} caps textColor={theIdea.slideHeaderColor}>
                    IDEA STAGE
                </Heading>
                <div style={{ height: stageHeight, flexDirection: flexDirection, justifyContent: justifyContent }} className='ideaSlideStages'>
                    <div style={{ marginTop: marginTop + 'px', display: 'block', width: 100 + '%' }}>
                        <IdeaStage
                            stage={theIdea.currentStage}
                            setStage={this.dummy.bind(this)}
                            stageNames={stages}
                        />
                    </div>
                    {(theIdea.dueDate && theIdea.dueDate !== '') &&
                        <div style={{ width: 100 + '%', display: 'block' }}>
                            <span style={{ color: theIdea.slideTextColor }} className='presentDueDate'>Due date: {dueDate}</span>
                        </div>
                    }
                </div>
            </Slide>
        return slide
    }

    recommendationSlide() {
        let slide = null
        const { stores } = this.props
        const { store } = stores
        const { theIdea } = store
        slide =
            <Slide align='flex-start' className='stagesSlides' progressColor={theIdea.slideHeaderColor} controlColor={theIdea.slideHeaderColor} key={63} bgColor={theIdea.slideBgColor}>
                <Heading className='introSlideName' key={54} style={{ fontSize: 3 + 'vw' }} caps textColor={theIdea.slideHeaderColor}>
                    RECOMMENDATION
                </Heading>
                <div className='ideaSlideRec'>
                    <div style={{ width: 100 + '%' }}>
                        <RecommendationLabel
                            effortRating={theIdea.effortRating}
                            impactRating={theIdea.impactRating}
                        />
                    </div>
                </div>
            </Slide>
        return slide
    }

    trimText(text) {
        var trimmedText = ''
        if (text !== undefined) {
            trimmedText = text.substring(0, 500)
        }
        return trimmedText
    }

    trimOneLineText(text, field) {
        var trimmedText = ''
        let limit = 0
        if (field === 'title') {
            limit = 60
        }
        else {
            limit = 100
        }
        if (text !== undefined) {
            trimmedText = text.substring(0, limit)
        }
        return trimmedText
    }

    renderToolSlide(toolName, slideTitle, loadedAllTools) {
        const { stores } = this.props
        const { store } = stores
        const { theIdea } = store
        let slide = []
        var totalCharAmount = 0
        var createSlide = []
        let whichSlide = 0
        const allTools = loadedAllTools
        let toolText = ''
        let generateSlide = false

        if (theIdea !== undefined && theIdea.hasOwnProperty([toolName])) {
            if (theIdea[toolName]) {
                totalCharAmount = 0
                for (var i = 0; i < allTools[toolName].length; i++) {
                    if (theIdea[toolName].hasOwnProperty(allTools[toolName][i].varName)) {
                        toolText = this.trimText(theIdea[toolName][allTools[toolName][i].varName])
                        totalCharAmount = totalCharAmount + toolText.length
                        if (totalCharAmount <= 600 && theIdea[toolName][allTools[toolName][i].varName].length > 1) {
                            createSlide[i] = whichSlide
                            generateSlide = true
                        }
                        else if (theIdea[toolName][allTools[toolName][i].varName].length > 1) {
                            totalCharAmount = totalCharAmount - 600
                            whichSlide++
                            createSlide[i] = whichSlide
                        }
                    }
                    if (generateSlide === true) {
                        let slideNumber = whichSlide
                        slide[whichSlide] =
                            <Slide align='flex-start' className='toolSlide' progressColor={theIdea.slideHeaderColor} controlColor={theIdea.slideHeaderColor} key={i + 1} bgColor={theIdea.slideBgColor}>
                                <Heading className='toolSlideHeader' key={i + 2} style={{ fontSize: 3 + 'vw' }} caps textColor={theIdea.slideHeaderColor}>
                                    {slideTitle}
                                </Heading>
                                {allTools[toolName].map((theTool, index) =>
                                    <div key={index}>

                                        {createSlide[index] === slideNumber &&
                                            <div className='ideaQuestionAnswerContainer' key={theTool.title}>
                                                {theIdea.showQuestions &&
                                                    <div key={index + 3} style={{ color: theIdea.slideTextColor }} className='toolSlideQuestion'><strong key={index + 7}>{theTool.title}</strong></div>
                                                }
                                                <div key={index + 11} style={{ color: theIdea.slideTextColor }} className='wordBreakTool'>{this.trimText(theIdea[toolName][theTool.varName])}</div>

                                                <div key={index + 5} className='slideEmptyGap' />
                                            </div>
                                        }
                                    </div>,
                                )}
                            </Slide>
                    }
                }
                return slide
            }
        }
    }

    dummy(something) { }

    render() {
        const { stores } = this.props
        const { store} = stores
        const { theIdea, theIdeaStatus } = store
        //Remove empty tool slides //TODO: UGLY!!!

        let loadedAllTools = []
        let loadedToolNames = []
        let loadedToolShowname = []

        for (const tool of loadedToolNames) {
            if (!theIdea[tool]) {
                theIdea[tool] = {}
            }
        }

        if (theIdea !== undefined) {
            this.state.loadedTeamTools.forEach(t => {
                let key = Object.keys(t)[0]
                loadedToolNames.push(key)
                loadedAllTools[key] = t[key].tools
                loadedToolShowname[key] = t[key].showName
            })
        }

        for (const tool of loadedToolNames) {
            if (theIdea !== undefined && theIdea.hasOwnProperty([tool])) {
                if (theIdea[tool]) {
                    var clo = helpers.cleanObj(theIdea[tool])
                    if (Object.keys(clo).length === 0) {
                        theIdea[tool] = undefined
                    }
                }
            }
        }
        if (theIdeaStatus !== 200) return null

        if (window.screen.availWidth < 600) {
            return browserHistory.goBack
        }

        var filteredSlides = []
        var z = 0
        let outputSlides = []

        if (theIdea !== undefined) {

            for (var b of theIdea.slides) {
                if (b.show === true) {
                    filteredSlides[z] = b
                    z++
                }
            }

            let slideFunctionMap = {
                intro: this.introSlide(),
                outro: this.outroSlide(),
                team: this.teamSlide(),
                need: this.needSlide(),
                timeline: this.timelineSlide(),
                sketch: this.sketchSlide(),
                viability: this.viabilitySlide(),
                richText: this.moreDescriptionSlide(),
                images: this.imageSlides(),
                stages: this.stagesSlide(this.state.loadedTeamStages),
                recommendation: this.recommendationSlide(),
            }
            const toolArr = loadedToolNames
            for (let t of toolArr) {
                let toolName = t
                slideFunctionMap[toolName] = this.renderToolSlide(toolName, loadedToolShowname[toolName], loadedAllTools)
                if (toolName === 'valueCreationTool') //FIXME: SILLY SILLY SILLY HACK
                    slideFunctionMap['valueTool'] = this.renderToolSlide('valueTool', loadedToolShowname['valueCreationTool'], loadedAllTools)
            }

            var y = 0
            for (var slide of filteredSlides) {
                outputSlides[y] = slideFunctionMap[slide.name]
                y++
            }

        }

        const theme = createTheme({
            primary: theIdea.slideBgColor,
            secondary: "#1B1B18",
            offWhite: "#F5F1EB",
            whiteText: "#F5F1EB",
        }, {
                primary: "Helvetica",
                secondary: "Helvetica",
            })

        //Creating presentation
        if (outputSlides.length > 0) {
            return (
                <div className='scrollableDeck'>
                    <KeyHandler keyEventName={KEYDOWN} keyValue='Escape' onKeyHandle={browserHistory.goBack} />
                    <Deck transition={["fade"]} progress={'bar'} transitionDuration={300} theme={theme}>
                        {outputSlides}
                    </Deck>
                    <div className='buttonStyle'>
                        <Glyphicon className='presentButton' onClick={browserHistory.goBack} glyph='remove-sign' style={{ color: '#ed1558', fontSize: 60 }} />
                    </div>
                    <div className='helpStyle'>
                        <ToolTip>
                            <Glyphicon glyph='question-sign' className='presentationHelp' />
                        </ToolTip>
                    </div>
                </div>
            )
        } else {
            return (
                <div>
                    <KeyHandler keyEventName={KEYDOWN} keyValue='Escape' onKeyHandle={browserHistory.goBack} />
                    <Deck transition={["fade"]} transitionDuration={300} theme={theme}>
                        <Slide bgColor={theIdea.slideBgColor}>
                            <Heading style={{ fontSize: 3 + 'vw' }} caps textColor={theIdea.slideHeaderColor}>
                                Empty idea
                            </Heading>
                            <Text textColor={theIdea.slideTextColor}>
                                <br />Add a bit more details to your idea before presenting
                            </Text>
                        </Slide>
                    </Deck>
                    <div className='buttonStyle'>
                        <Glyphicon className='presentButton' onClick={browserHistory.goBack} glyph='remove-sign' style={{ color: '#ed1558', fontSize: 60 }} />
                    </div>
                    <div className='helpStyle'>
                        <ToolTip>
                            <Glyphicon glyph='question-sign' className='presentationHelp' />
                        </ToolTip>
                    </div>
                </div>
            )
        }
    }
}
PresentIdea.propTypes = {
    ideaKey: PropTypes.string,
    dataRows: PropTypes.array,
}

export default inject("stores")(observer(PresentIdea))



// WEBPACK FOOTER //
// ./src/containers/PresentIdea.js